export function pruneValue<T>(value: T): T | undefined {
    if (value === null || value === undefined) {
        return undefined;
    }

    if (Array.isArray(value)) {
        const pruned = value.map((item) => pruneValue(item)).filter((item) => item !== undefined);

        return pruned.length ? (pruned as T) : undefined;
    }

    if (typeof value === 'object') {
        const pruned = Object.fromEntries(
            Object.entries(value)
                .map(([key, item]) => [key, pruneValue(item)])
                .filter(([, item]) => item !== undefined)
        );

        return Object.keys(pruned).length ? (pruned as T) : undefined;
    }

    if (typeof value === 'string') {
        const trimmed = value.trim();
        return trimmed === '' ? undefined : (trimmed as T);
    }

    return value;
}
